import { authClient, API } from "../index";

// Mesas de una sesión
export const getTablesBySession = (sessionId) => {
	return authClient().get(`${API}/table/session/${sessionId}`);
};

// Mesa por id
export const getTableById = (id) => {
	return authClient().get(`${API}/table/${id}`);
};

// Renombrar / editar participantes: { name?, participants? }
export const updateTable = (id, body) => {
	return authClient().put(`${API}/table/${id}`, body);
};

// Eliminar mesa y sus datos
export const deleteTable = (id) => {
	return authClient().delete(`${API}/table/${id}`);
};
